import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Box, Button, Grid, Paper, TextField, Typography, Modal, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';
import { getAdminRequest, getUsersUnderCompany, deleteAdminRequest, deleteUsersUnderCompany, updateAdminRequest, updateUsersUnderCompany, addOrganisationRequest, getOrganisation, deleteOrgnisation, getArchiveList, restoreProject } from '../Redux/Actions/adminScreenActions'
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import CreateOrganisationModel from '../components/admin/CreateOrganisationModel';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from 'react-router-dom';
import Table from '../../src/components/common/table/Table';
import { toast } from 'react-toastify';
import RestoreIcon from '@mui/icons-material/Restore';


function CompanyAdminScreen() {
    const [value, setValue] = useState(0);
    const [modalData, setModalData] = useState({})
    const [open, setOpen] = useState(false)
    const [isAdmin, setIsAdmin] = useState()
    const [isAddOrganisation, setIsAddOrganisation] = useState(false);
    const [currentPage, setCurrentPage] = useState(1)


    let dispatch = useDispatch()
    const navigate = useNavigate();

    // states from store for tab panel 1 (user List)
    const { userListData } = useSelector((state) => state.getUserList)
    const { updateUserData } = useSelector((state) => state.updateUserList)
    const { deleteUserData } = useSelector((state) => state.deleteUserList)
    const { deleteOrganisationData } = useSelector((state) => state.deleteOrganisation)
    
    const { up } = useSelector((state) => state.deleteUserList)
    
    // states from store for tab panel 2 (user requests)
    const { getListData } = useSelector((state) => state.adminRequest)
    const { updatedList } = useSelector((state) => state.updateRequest)
    const { deleteSuccess } = useSelector((state) => state.deleteRequest)

    const { getOrganisationData, getOrganisationLoading } = useSelector((state) => state.getOrganisation);
    const { getArchiveListData } = useSelector((state) => state.getArchiveList);
    const { restoreProjectData } = useSelector((state) => state.restoreProjectData);

    useEffect(() => {
        dispatch(getOrganisation())
    }, [updateUserData, deleteOrganisationData])

    useEffect(() => {
        dispatch(getArchiveList())
    }, [restoreProjectData])

    useEffect(() => {
        dispatch(getAdminRequest())
    }, [updatedList, deleteSuccess])


    const errorTheme = {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    }


    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box sx={{ p: 3 }}>
                        <Grid>{children}</Grid>
                    </Box>
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
        console.log("newValue", newValue);
    };

    const deleteUserHandler = (user_id) => {
        dispatch(deleteOrgnisation(user_id))
    }

    const handleRestore =(project_id)=>{
        dispatch(restoreProject(project_id))
    }

    const organisationPageSize = 5
    const handlePageChange = (page) => {
        setCurrentPage(page)
    }

    const columns = [
        { accessor: 'id', header: 'Id' },
        {
            accessor: 'partner_name',
            header: 'Partner Name',
            cell: (value) => value ? value?.replace(/\b\w/g, (char) => char.toUpperCase()) : "N/A",
        },
        {
            accessor: 'name',
            header: 'Organisation Name',
            cell: (value) => value ? value.replace(/\b\w/g, (char) => char.toUpperCase()) : "N/A",
        },
        {
            accessor: 'active_date',
            header: 'Active Date',
            cell: (value) => value ? new Date(value).toLocaleDateString('en-GB') : "N/A",
        },
        {
            accessor: 'expiry_date',
            header: 'Expiry Date',
            cell: (value) => value ? new Date(value).toLocaleDateString('en-GB') : "N/A",
        },
        {
            accessor: 'company_admin_name',
            header: 'Company Admin',
            cell: (value) => value ? value.replace(/\b\w/g, (char) => char.toUpperCase()) : "N/A",
        },
        {
            accessor: 'Actions',
            header: 'Actions',
            cell: (value, row) => {
            const handleDeleteClick = (e) => {
                e.stopPropagation();
                const rowId = row.id;
                deleteUserHandler(rowId);
                };

                return (
                <Grid display={"flex"} gap={2}>
                    <Typography
                    onClick={() => navigate(`/super-admin/organisation-details/${row.id}`)}
                    sx={{
                        color: 'blue',
                        '&:hover': { color: 'lightblue', scale: '125%' },
                    }}
                    >
                    <VisibilityIcon fontSize="medium" />
                    </Typography>
                    <Typography
                    onClick={handleDeleteClick}
                    sx={{
                        color: '#e11d48',
                        '&:hover': { color: '#fb7185', scale: '125%' },
                    }}
                    >
                    <DeleteIcon fontSize="medium" />
                    </Typography>
                </Grid>
                );
            }
        }
    ];


    const archiveListColumns = [
    { accessor: '_id', header: 'ID' },
    { accessor: 'project_name', header: 'Project Name' },
    { accessor: 'application_type', header: 'Application Type' },
    { accessor: 'updatedAt', header: 'Deleted Time',
            cell: (value) => value ? new Date(value).toLocaleDateString('en-GB') : "N/A",
     },
    {
            accessor: 'actions',
            header: 'Actions',
            cell: (value, row) => {
                return (
                <Grid display={"flex"} gap={2}>
                    <Typography
                    onClick={() => handleRestore(row._id)}
                    sx={{
                        color: 'blue',
                        '&:hover': { color: 'lightblue', scale: '125%' },
                    }}
                    >
                    <RestoreIcon fontSize="medium" />
                    </Typography>
                </Grid>
                )
            }
        }
];

    const dummy_rows = [
    {
        id: 1,
        partner_name: "John Doe",
        organisation_name: "Tech Solutions Ltd.",
        license_generator: "RS25-XXXX-XXXX-XXXX",
        active_date: "2025-01-31",
        expiry_date: "2025-12-31",
        company_admin: "John Doe",
        no_of_dockers: "10/5"
    },
    {
        id: 2,
        partner_name: "Jane Smith",
        organisation_name: "InnovateX Pvt Ltd.",
        license_generator: "RS25-XXXX-XXXX-XXXX",
        active_date: "2024-01-15",
        expiry_date: "2024-12-15",
        company_admin: "John Doe",
        no_of_dockers: "8/4"
    },
    {
        id: 3,
        partner_name: "David Johnson",
        organisation_name: "CloudTech Inc.",
        license_generator: "RS25-XXXX-XXXX-XXXX",
        active_date: "2025-06-20",
        expiry_date: "2026-06-20",
        company_admin: "John Doe",
        no_of_dockers: "15/10"
    },
    {
        id: 4,
        partner_name: "Emily Brown",
        organisation_name: "AI Ventures",
        license_generator: "RS25-XXXX-XXXX-XXXX",
        active_date: "2024-09-10",
        expiry_date: "2025-09-10",
        company_admin: "John Doe",
        no_of_dockers: "12/6"
    },
    {
        id: 5,
        partner_name: "Michael Lee",
        organisation_name: "CyberSec Corp.",
        license_generator: "RS25-XXXX-XXXX-XXXX",
        active_date: "2023-08-25",
        expiry_date: "2024-08-25",
        company_admin: "John Doe",
        no_of_dockers: "20/15"
    }
];



    const pageSize = 10
    const totalItems = dummy_rows.length


    const currentUser = JSON.parse(localStorage.getItem('userInfo'));

    const currentUserList = userListData?.length && userListData?.filter((x) => x._id !== currentUser._id)

    const rows = userListData?.length ? currentUserList?.map((x) => {

        return {
            id: x._id,
            userName: x.name,
            userEmail: x.email,
            isAdmin: x.company_admin,
        }


    }) : [
        { id: 1, userName: 'jon', userEmail: 'Jon@gmail.com', isAdmin: 'false' },
        { id: 2, userName: 'mike', userEmail: 'mike@gmail.com', isAdmin: 'false' },
        { id: 3, userName: 'marty', userEmail: 'marty@gmail.com', isAdmin: 'false' },
        { id: 4, userName: 'wendy', userEmail: 'wendy@gmail.com', isAdmin: 'false' },
        { id: 5, userName: 'ruth', userEmail: 'ruth@gmail.com', isAdmin: 'true' },
        { id: 6, userName: 'james', userEmail: 'James@gmail.com', isAdmin: 'false' },

    ];

    // const requestData = [
    //     {
    //         name: 'kailash',
    //         email: 'kailash.bhatt@123'
    //     },
    //     {
    //         name: 'randomUser',
    //         email: 'randomUser@123'
    //     },
    //     {
    //         name: 'testUser',
    //         email: 'johnWick@gmail.com'
    //     }
    // ]

    const deleteRequestHandler = (request_id) => {
        dispatch(deleteAdminRequest(request_id))
    }

    const updateRequestHandler = (request_id) => {
        dispatch(updateAdminRequest(request_id))
    }

    const addOrganisationHandler = async(organisationData)=>{
        try {
            await dispatch(addOrganisationRequest(organisationData)); // Ensure it's a Promise
            setIsAddOrganisation(false);
            dispatch(getOrganisation());
        } catch (error) {
            console.error("Failed to create organisation", error);
        }
    }

    const reqListColumns = [
        { field: 'id', headerName: 'ID', width: 150 },
        {
            field: 'userName',
            headerName: 'User Name',
            width: 250,
            editable: false,
        },
        {
            field: 'userEmail',
            headerName: 'Email',
            width: 350,
            editable: false,
        },
        {
            field: 'Approve',
            headerName: '',
            width: 130,
            renderCell: (params) => {
                return (
                    // <Button variant='contained' sx={{ color: '#fecdd3', backgroundColor: '#e11d48', '&:hover': { color: '#e11d48', backgroundColor: '#fecdd3' } }} >Delete</Button>
                    <Button onClick={(e) => {
                        e.stopPropagation();
                        updateRequestHandler(params.row.id)
                    }} variant='contained' sx={{ color: '#ecfccb', backgroundColor: "#84cc16", '&:hover': { color: '#84cc16', backgroundColor: '#ecfccb' } }
                    }>
                        Approve
                    </Button>

                )
            }
        },
        {
            field: 'Delete',
            headerName: '',
            width: 130,
            renderCell: (params) => {
                return (
                    // <Button variant='contained' sx={{ color: '#fecdd3', backgroundColor: '#e11d48', '&:hover': { color: '#e11d48', backgroundColor: '#fecdd3' } }} >Delete</Button>
                    <Button onClick={(e) => {
                        e.stopPropagation();
                        deleteRequestHandler(params.row.id)
                    }} variant='contained' sx={{ color: '#ffe4e6', backgroundColor: "#e11d48", '&:hover': { color: '#e11d48', backgroundColor: '#ffe4e6' } }
                    }>
                        Decline
                    </Button>

                )
            }
        }
    ]

    const reqListRows = getListData ? getListData?.map((x) => {
        return {
            id: x._id,
            userName: x.name,
            userEmail: x.email
        }
    }) : [
        { id: 1, userName: 'jon', userEmail: 'Jon@gmail.com' },
        { id: 2, userName: 'mike', userEmail: 'mike@gmail.com' },
        { id: 3, userName: 'marty', userEmail: 'marty@gmail.com' },
        { id: 4, userName: 'wendy', userEmail: 'wendy@gmail.com' },
        { id: 5, userName: 'ruth', userEmail: 'ruth@gmail.com' },
        { id: 6, userName: 'james', userEmail: 'James@gmail.com' },

    ];


    const handleRowEventHandler = (params) => {
        setModalData({
            name: params.row.userName,
            email: params.row.userEmail,
            _id: params.row.id,
            company_admin: params.row.isAdmin
        })
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const isAdminOptionHandler = (event) => {
        if (event.target.value === 10) {
            setIsAdmin(true);
        } else {
            setIsAdmin(false);
        }

    };

    const updateUserDataHandler = (user_id) => {
        dispatch(updateUsersUnderCompany({ user_id, company_admin: isAdmin }))
        setOpen(false)
    }

    return (
        <>

            <Paper elevation={4} style={{ margin: '3% 5% 5% 5%', height: '70vh' }}>
                <Grid display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example"
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: "red",

                            }
                        }}>
                        <Tab label={<Paper elevation={4} sx={{ backgroundColor: value === 0 ? 'red' : 'white', color: value === 0 ? 'white' : 'red', padding: '1vh 2vw', fontFamily: 'Mont-Regular' }}>ORGANISATION LIST</Paper>} {...a11yProps(0)} />
                        <Tab label={<Paper elevation={4} sx={{ backgroundColor: value === 1 ? 'red' : 'white', color: value === 1 ? 'white' : 'red', padding: '1vh 2vw', fontFamily: 'Mont-Regular' }}>USER REQUEST'S </Paper>} {...a11yProps(1)} />
                        <Tab label={<Paper elevation={4} sx={{ backgroundColor: value === 2 ? 'red' : 'white', color: value === 2 ? 'white' : 'red', padding: '1vh 2vw', fontFamily: 'Mont-Regular' }}>Archive List </Paper>} {...a11yProps(2)} />
                    </Tabs>
                    <Button onClick={()=>setIsAddOrganisation(!isAddOrganisation)} sx={{ boxShadow: 2, color:"white",mx: 3, bgcolor: 'red', '&:hover': { boxShadow: 5, bgcolor:"red" } }}>
                        <AddIcon />
                        Add Organization
                    </Button>
                </Grid>
                <TabPanel value={value} index={0} >

                    <Grid sx={{ height: '50vh' }}>
                        {getOrganisationLoading ? (
                                <p>Loading...</p>
                            ) : getOrganisationData?.length > 0 ? (
                        <Table
                            columns={columns}
                            data={getOrganisationData}
                            pagination={{
                                currentPage,
                                pageSize: organisationPageSize,
                                totalItems: getOrganisationData?.length,
                                onPageChange: handlePageChange,
                            }}
                            className="bg-white rounded-lg shadow"
                            />
                            ) : (
                                <p className="text-gray-500 text-center py-4">No data available</p>
                            )}
    
                    </Grid>


                </TabPanel>
                <TabPanel value={value} index={1}>

                    {
                        getListData?.length > 0 ? <Grid sx={{ height: '45vh' }}>
                            <DataGrid
                                rows={reqListRows}
                                columns={reqListColumns}
                                pageSize={4}
                                // onRowClick={(params) => handleRowEventHandler(params)}
                                // error={error}
                                rowsPerPageOptions={[4]}
                                checkboxSelection
                                disableSelectionOnClick
                                experimentalFeatures={{ newEditingApi: true }}
                                IsReadOnly="True"
                            />
                        </Grid> : <Grid sx={{ height: '45vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Typography sx={{ fontSize: '1.5rem', fontFamily: 'Mont-Semibold' }}>Currently, You don't have Pending Requests .</Typography>
                        </Grid>}
                </TabPanel>


                <TabPanel value={value} index={2} >

                    <Grid sx={{ height: '50vh' }}>
                        {getArchiveListData?.projects?.length > 0 ? (
                        <Table
                            columns={archiveListColumns}
                            data={getArchiveListData?.projects}
                            pagination={{
                                currentPage,
                                pageSize: organisationPageSize,
                                totalItems: getArchiveListData?.projects?.length,
                                onPageChange: handlePageChange,
                            }}
                            className="bg-white rounded-lg shadow"
                            />
                            ) : (
                                <p className="text-gray-500 text-center py-4">No data available</p>
                            )}
    
                    </Grid>


                </TabPanel>

            </Paper>

            <Modal
                open={open}
                onClose={handleClose}

                sx={{ border: 'none', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >

                <Box sx={{ width: { lg: '80vw' }, padding: '2vh 2vw 6vh 2vw', outline: 'none', borderRadius: '6px', backgroundColor: 'white', position: 'relative' }}>
                    <Grid sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button onClick={handleClose} sx={{ boxShadow: 2, color: 'red', '&:hover': { boxShadow: 5 } }}>
                            <CloseIcon />
                        </Button>
                    </Grid>
                    <Grid sx={{ display: "flex", justifyContent: 'space-between', alignItems: 'center', mt: 2 }} >
                        <Typography sx={{ fontFamily: "Mont-SemiBold", fontSize: '1.3rem' }}>Update User</Typography>
                        <Grid item xs={10.2} sx={{ backgroundColor: 'red', height: "1vh" }}></Grid>
                    </Grid>
                    <Grid sx={{ mt: 4, display: 'flex', justifyContent: 'space-between' }}>
                        <TextField id="outlined-basic" label="User Name" variant="outlined" sx={{ width: "36vw" }} defaultValue={modalData?.name} disabled />
                        <TextField defaultValue={modalData?.email} id="outlined-basic" label="User Email" variant="outlined" sx={{ width: "36vw" }} disabled />
                    </Grid>
                    <Grid sx={{ mt: 4, display: 'flex', justifyContent: 'space-between' }}>

                        <FormControl sx={{ width: "36vw" }}>
                            <InputLabel id="demo-simple-select-label">grant admin access</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                defaultValue={modalData?.company_admin}
                                label="grant admin access"
                                onChange={isAdminOptionHandler}
                            >
                                <MenuItem value={10}>True</MenuItem>
                                <MenuItem value={20}>False</MenuItem>
                            </Select>
                        </FormControl>
                        <Button onClick={updateUserDataHandler} variant='contained' sx={{ backgroundColor: 'red', '&:hover': { color: 'red', backgroundColor: 'white' } }}>Save Changes</Button>
                    </Grid>

                </Box>
            </Modal>

            <CreateOrganisationModel open={isAddOrganisation} handleClose={()=>setIsAddOrganisation(false)} addOrganisation={addOrganisationHandler}/>
        </>
    )
}

export default CompanyAdminScreen